import React, { useRef, useEffect } from "react";
import classes from "./Stats.module.css";
import Container from "../../UI/Container/Container";
import image from "../../../assets/images/sustainable-solar.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Stats = (props) => {
  const sectionRef = useRef(0);
  const statOneRef = useRef(0);
  const statTwoRef = useRef(0);
  const statThreeRef = useRef(0);
  const statFourRef = useRef(0);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 50%",
      },
    });

    timeline.to(statOneRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statTwoRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statThreeRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statFourRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
  });

  return (
    <div ref={sectionRef} className={classes.Stats}>
      <img src={image} alt="Solar panels on the College Solar Farm" />
      <div className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <div className={classes.Row}>
              <div ref={statOneRef} className={classes.Column}>
                <p>
                  In 2020, Dickinson became one of the first{" "}
                  <span>CARBON-NEUTRAL COLLEGES</span> in the country!
                </p>
              </div>
              <div ref={statTwoRef} className={classes.Column}>
                <p>
                  One of only 25 schools in the nation to consistently receive a{" "}
                  <span>99 GREEN RATING</span> in the{" "}
                  <span>PRINCETON REVIEW GREEN HONOR ROLL</span>
                </p>
              </div>
            </div>
            <div className={classes.Row}>
              <div ref={statThreeRef} className={classes.Column}>
                <p>
                  <span>180-ACRE COLLEGE FARM</span> (with 60 acres managed,
                  annually producing more than 100,000 pounds of USDA-certified
                  organic produce)
                </p>
              </div>
              <div ref={statFourRef} className={classes.Column}>
                <p>
                  Sierra magazine ranks Dickinson the{" "}
                  <span>NO. 14 COOLEST SCHOOL</span> for sustainability efforts
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Stats;
